import useScreenSize from '@/hooks/useScreenSize';
import ArtworkImage from '@/shared-components/cards/components/ArtworkImage';

import './styles/HomeAuctionBanner.css';

export default function HomeAuctionBanner({
  mobileImage,
  desktopImage,
  alt,
  onClick,
}) {
  const { width } = useScreenSize();
  const imageSrc = width <= 550 ? mobileImage : desktopImage;

  return (
    <div className="home-auction-banner" onClick={onClick}>
      {/* Match HomeBanner responsive behaviour while stripping extra UI */}
      <ArtworkImage
        image={imageSrc}
        imageClassName="home-auction-banner__image"
        imageTemplateClassName="home-auction-banner__image"
        alt={alt}
      />
    </div>
  );
}
